import request from '@/utils/request'

export function editDemo (data) {
  return request({
    url: '/editDemo',
    method: 'post',
    data
  })
}

export function getDemoById (data) {
  return request({
    url: '/getDemoById',
    method: 'post',
    data
  })
}
